import { Helmet } from 'react-helmet';
import { useState } from 'react';
import '../assets/styles/ContactUs.css';

function ContactUs() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('success');
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <>
      <Helmet>
        <title>RFF Cargo: Contact Us</title>
        <meta name="description" content="Get in touch with RFF Cargo for your logistics inquiries." />
      </Helmet>
      <section className="contact-us-section py-5">
        <div className="container">
          <h2 className="contact-title fw-bold mb-4">Contact Us</h2>
          <p className="contact-description">
            Reach out to our team for support or inquiries about our services.
          </p>
          <div className="row">
            {/* Left Column: Office Locations */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h3 className="office-title fw-bold mb-3">Kenya Office</h3>
              <ul className="office-list">
                <li className="office-list-item">
                  <i className="bi bi-geo-alt-fill me-2" aria-label="Location"></i>
                  <span>Mombasa, Nyerere Road at Palli House</span>
                </li>
                <li className="office-list-item">
                  <i className="bi bi-telephone-fill me-2" aria-label="Phone"></i>
                  <span>+254 725 222 600</span>
                </li>
                <li className="office-list-item">
                  <i className="bi bi-envelope-fill me-2" aria-label="Email"></i>
                  <span>mhareed@rffcargo.co.ke</span>
                </li>
              </ul>
              <h3 className="office-title fw-bold mb-3 mt-4">India Office</h3>
              <ul className="office-list">
                <li className="office-list-item">
                  <i className="bi bi-geo-alt-fill me-2" aria-label="Location"></i>
                  <span>2nd Floor, Metro House, 12/A, Colaba Causeway, opposite Hotel Majestic Building, Apollo Bandar, Colaba, Mumbai, Maharashtra 400039, India</span>
                </li>
                <li className="office-list-item">
                  <i className="bi bi-telephone-fill me-2" aria-label="Phone"></i>
                  <span>+91 842 743 3320</span>
                </li>
                <li className="office-list-item">
                  <i className="bi bi-envelope-fill me-2" aria-label="Email"></i>
                  <span>kaarshe30@gmail.com</span>
                </li>
              </ul>
              <h3 className="office-title fw-bold mb-3 mt-4">Dubai Office</h3>
              <ul className="office-list">
                <li className="office-list-item">
                  <i className="bi bi-geo-alt-fill me-2" aria-label="Location"></i>
                  <span>High River Shipping & Cargo LLC, Dubai Tower 308C, Baniyas Square</span>
                </li>
                <li className="office-list-item">
                  <i className="bi bi-telephone-fill me-2" aria-label="Phone"></i>
                  <span>+971 56 372 6013</span>
                </li>
                <li className="office-list-item">
                  <i className="bi bi-envelope-fill me-2" aria-label="Email"></i>
                  <span>yacubebashir@rffcargo.co.ke</span>
                </li>
              </ul>
            </div>
            {/* Right Column: Contact Form */}
            <div className="col-lg-6">
              {status === 'success' && (
                <div className="alert alert-success alert-dismissible fade show" role="alert">
                  Your message has been sent successfully!
                  <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
              )}
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    aria-required="true"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    aria-required="true"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="message" className="form-label">Message</label>
                  <textarea
                    className="form-control"
                    id="message"
                    rows="4"
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    required
                    aria-required="true"
                  ></textarea>
                </div>
                <button type="submit" className="btn btn-submit">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactUs;